import React, { useEffect, useState } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import 'dayjs/locale/ja'
import * as api from '@/apis/aipass'
import { sectionHeaderStyle } from '@/components/organisms/dashboard/style'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { LinkPreviewTextarea } from '@/components/molecules/link-preview-textarea'

type Props = {
  note: string
  setIsLoading: (isLoading: boolean) => void
}
export const MessageBoardByCommonly: React.FC<Props> = props => {
  const { t } = useTranslation()
  const [originNote, setOriginNote] = useState<string>('')
  const [inputNote, setInputNote] = useState<string>('')
  const [isEditing, setIsEditing] = useState<boolean>(false)

  const updateDashboardNote = async () => {
    props.setIsLoading(true)
    await api.updateDashboardNote({
      date: undefined,
      note: inputNote,
    })
    setOriginNote(inputNote)
    setIsEditing(false)
    props.setIsLoading(false)
  }

  const onCancel = () => {
    setInputNote(originNote)
    setIsEditing(false)
  }

  useEffect(() => {
    setOriginNote(props.note)
    setInputNote(props.note)
  }, [props.note])

  return (
    <div>
      <div css={messageBoardHeaderStyle}>
        <div css={TitleStyle}>
          <img width={16} src={require('@/static/images/calendar_icon.svg')} style={{ padding: '1px 0' }} />
          {t('Commonly')}
        </div>
        {isEditing ? (
          <>
            <Button
              buttonType={ButtonType.Secondary}
              width="auto"
              paddingLeft={10}
              paddingRight={10}
              height={32}
              fontSize={12}
              onClick={onCancel}
            >
              {t('Cancel')}
            </Button>
            <Button
              buttonType={ButtonType.Primary}
              width="auto"
              paddingLeft={20}
              paddingRight={20}
              height={32}
              fontSize={12}
              onClick={updateDashboardNote}
            >
              {t('Save')}
            </Button>
          </>
        ) : (
          <Button
            buttonType={ButtonType.Secondary}
            width="auto"
            paddingLeft={20}
            paddingRight={20}
            height={32}
            fontSize={12}
            onClick={() => setIsEditing(true)}
          >
            {t('Edit')}
          </Button>
        )}
      </div>
      <div css={memoBlockStyle}>
        <LinkPreviewTextarea
          customCss={css({
            lineHeight: '21px',
            fontSize: 14,
            height: 160,
          })}
          onClick={() => setIsEditing(true)}
          value={inputNote}
          onChange={v => setInputNote(v.target.value)}
        />
      </div>
    </div>
  )
}

const messageBoardHeaderStyle = css(sectionHeaderStyle, {
  gap: 16,
  marginLeft: 0,
  padding: '0 16px',
})

const TitleStyle = css({
  color: '#272727',
  display: 'flex',
  alignItems: 'center',
  gap: 4,
})

const memoBlockStyle = css({
  padding: '0 16px',
  width: '100%',
})
